import Gettext, { GettextInterface, LocaleData } from '@indeed/indeed-gettext';

let getTextInstance: GettextInterface;

const getTextClient = {
    initialize: (localeData: LocaleData) => {
        getTextInstance = Gettext(localeData);
        return localeData;
    },
    get: () => {
        if (getTextInstance === undefined) {
            throw Error('getTextClient was not Initialized!');
        }

        return getTextInstance;
    }
};

export default getTextClient;
